import { gql } from "@apollo/client";

export default {};

export const getAmeList = gql`
    {
        getAmes {
            first_name
            id
            last_name
        }
    }
`;

export const getAircraftList = gql`
    {
        getAircraft {
            AircraftType {
                id
                name
                sort_order
            }
            aircraft_type_id
            callsign
            id
            name
            registration
        }
    }
`;

export const getCompanyBasesList = gql`
    {
        getCompanyBases {
            id
            airport_code
            company_id
            label
            Airport {
                name
            }
        }
    }
`;

export const getCompanyList = gql`
    {
        getClients {
            id
            name
        }
    }
`;

export const getLineItemList = gql`
    {
        getTicketLineItemTypes {
            code
            id
            is_customer
            is_default
            is_mandatory
            is_operator
            is_rate
            label
        }
    }
`;

export const getPilotList = gql`
    {
        getPilots {
            email_work
            first_name
            id
            initials
            last_name
            middle_name
        }
    }
`;

export const getJobList = gql`
    query GetJobList($startDate: String) {
        getJobs(date_range_start: $startDate) {
            id
            accommodation_provided_by
            aircraft_minimum
            aircraft_type_id
            base_airport_code
            company_id
            customer_po
            deleted_at
            depart_or_arrive_location
            depart_or_arrive_time
            depart_or_arrive_tz
            departure_from
            description
            end_date
            flight_rule_id
            fuel_rate
            is_dg
            job_status_id
            job_type_id
            label
            parent_job_id
            meals_provided_by
            pilot_minimum
            rate
            rate_type_id
            rate_units
            start_date
            JobAircraft {
                aircraft_id
                start_date
                end_date
            }
            JobAssignments {
                assignable_id
                assignable_resource_type_id
                assigned_person
                assigned_person_id
                assigned_role
                assignment_begin
                assignment_end
                associable_id
                associated_id
                associated_model
                job_id
            }
            JobType {
                id
                deleted_at
                description
                label
                sort_order
            }
            JobStatus {
                id
                deleted_at
                description
                is_active
                is_available
                is_cancelled
                is_complete
                is_pending
                label
                label_colour
                sort_order
                text_colour
            }
            JobContacts {
                assignable_id
                assignable_resource_type_id
                contact_person
                contact_type
                email
                first_name
                job_id
                last_name
                person_id
                phone
            }
            JobPax {
                assignable_id
                assignable_resource_type_id
                email
                first_name
                job_id
                last_name
                pax_name
                person_id
                phone
                weight
            }
        }
    }
`;

export const getQuantityTypeList = gql`
    {
        getQuantityTypes {
            id
            label
            scope
        }
    }
`;

export const getRiskAssessmentFactorList = gql`
    {
        getRiskAssessmentFactors {
            id
            factor_type_id
            label
            value
        }
    }
`;

export const getSignableResourceTypeList = gql`
    {
        getSignableResourceTypes {
            id
            label
        }
    }
`;

export const getTicketList = gql`
    query GetTicketsByPersonId($pilotId: Int!) {
        getTicketsByPersonId(person_id: $pilotId) {
            id
            date
            Job {
                label
                customer_po
                start_date
                end_date
                JobType {
                    label
                }
                JobStatus {
                    id
                }
            }
            LineItems {
                amount
                comments
                id
                line_item_type_id
                quantity
                quantity_type_id
                ticket_id
                total
                is_selected
            }
            Locations {
                cost_code
                down_time
                hours
                id
                location
                ticket_id
                up_time
                sort_order
            }
            Pax {
                id
                name
                ticket_id
            }
            Signatures {
                company
                date
                id
                model
                ref_id
                signable_resource_type_id
                signatory
                signatory_job_title
                signatory_email
                signature
                signed_by
                ResourceType {
                    id
                    is_external
                    label
                    scope
                }
            }
            aircraft_id
            airport_code
            ame_person_id
            averaged_days
            comments
            company_id
            contact_email
            contact_name
            contact_phone
            customer_po
            is_aircraft_substituted
            is_averaged
            is_minimum
            job_id
            job_location
            num_pax
            pilot_person_id
            pilot_person_id2
            rate
            substituted_aircraft_id
            ticket_num
            signature_pending
            up_down_required
            up_time
            down_time
            is_no_fly
            any_landings
            is_per_diems
            is_other_charges
            see_passenger_manifest
            revision_num
            completed_date
        }
    }
`;

export const getUserQuery = gql`
    {
        currentLegacyUser {
            id
            first_name
            last_name
        }
    }
`;

export const DELETE_TICKET = gql`
    mutation DeleteTicket($id: Int!) {
        deleteTicket(id: $id)
    }
`;

export const CREATE_OR_UPDATE_TICKET = gql`
    mutation CreateOrUpdateTicket($ticket: JSON!) {
        createOrUpdateTicket(ticket: $ticket) {
            LineItems {
                amount
                comments
                id
                is_selected
                line_item_type_id
                quantity
                quantity_type_id
                ticket_id
                total
            }
            Locations {
                cost_code
                down_time
                hours
                id
                location
                ticket_id
                up_time
                sort_order
            }
            Pax {
                id
                name
                ticket_id
            }
            Signatures {
                company
                date
                id
                model
                ref_id
                signable_resource_type_id
                signatory
                signatory_email
                signatory_job_title
                signature
                signed_by
            }
            aircraft_id
            airport_code
            ame_person_id
            averaged_days
            comments
            company_id
            contact_email
            contact_name
            contact_phone
            customer_po
            date
            id
            is_aircraft_substituted
            is_averaged
            is_minimum
            job_id
            job_location
            num_pax
            pilot_person_id
            pilot_person_id2
            rate
            substituted_aircraft_id
            ticket_num
            signature_pending
            up_down_required
            up_time
            down_time
            is_no_fly
            any_landings
            is_per_diems
            is_other_charges
            see_passenger_manifest
            revision_num
            completed_date
        }
    }
`;
